import { useState } from 'react';
import { InputCard } from '@components/cards';
import { RADIO } from '@components/cards/input-card/src/input-card.type';
import { EmptyBlock } from '@components/empty-block';
import { IconEmpty } from '@components/icons';
import { Loader } from '@components/loader';
import { useGetAdminUsers } from '@hooks/use-get-admin-users/use-get-admin-users';

import { ImpersonateUserListContentProps } from './impersonate-user-modal.type';

export const ImpersonateUserListContent = ({ email, setSelectedUser }: ImpersonateUserListContentProps) => {
  const { data, isLoading } = useGetAdminUsers({ email }, { enabled: !!email, disableLoading: true });
  const [isChecked, setIsChecked] = useState(false);

  const handleClick = () => {
    setIsChecked((prev) => !prev);
    setSelectedUser(data);
  };

  return (
    <div className='mt-6'>
      {isLoading && <Loader />}
      {!data && (
        <div data-testid='impersonate-modal--list-empty'>
          <EmptyBlock title={'No email, no party'}>
            <IconEmpty className='my-3 text-gray-500 dark:text-white' />
          </EmptyBlock>
        </div>
      )}
      {data && (
        <InputCard isChecked={isChecked} isDisabled={false} type={RADIO} handleClick={handleClick}>
          <div data-testid='impersonate-modal--list-content'>
            <p className='text-base text-left font-bold text-primary'>{data.fullName}</p>
            <p className='text-sm text-left text-gray-700 dark:text-white'>{data.email}</p>
          </div>
        </InputCard>
      )}
    </div>
  );
};
